module.exports = __webpack_public_path__ + "hM0gekQOUVruWAbHF/rdc_pro_logo.svg";